const status_list = ['', '导购', '编外']

export function initFinderConfig (ctx) {
  let that = ctx
  if (!that) return console.error('finder初始化未接收到绑定上下文')
  return {
    requestUrl: process.env.VUE_APP_BASE_API + '/salesperson/unique-visito/list',
    columns: [
      {
        name: '员工工号',
        key: 'employee_number'
      },
      {
        name: '员工姓名',
        key: 'salesperson_name'
      },
      {
        name: '所属门店',
        key: 'store_name'
      },
      {
        name: '类型',
        key: 'employee_status',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return (
            <div class='status'>
              {row.employee_status && <span>{status_list[row.employee_status]}</span>}
            </div>
          )
        }
      },
      {
        name: '月客户UV',
        key: 'count'
      }
    ],
    search: [
      { key: 'month', name: '', slot: 'month' },
      { key: 'name', name: '', slot: 'name' },
      { key: 'guide', name: '', slot: 'guide' }
    ],
    actions: [
      {
        name: '导出',
        key: 'create',
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          handler: () => {
            that.exportDialogVisible = true
          }
        }
      }
    ]
  }
}

export default initFinderConfig
